import React from 'react'

import { MenuPage } from 'routes/Menu/MenuExperience/MenuPage'
import { MenuRecipesPageWrapper } from 'routes/Menu/MenuRecipesPage'
import { useIsNewMenuNavEnabled } from 'routes/Menu/hooks/useIsNewMenuNavEnabled'

type MenuRouterProps = {
  params: {
    orderId?: string
  }
  location: {
    query: Record<string, unknown>
  }
}

export const MenuRouter = ({ params, location }: MenuRouterProps) => {
  const isNewMenuNavEnabled = useIsNewMenuNavEnabled()

  if (isNewMenuNavEnabled) {
    return <MenuPage params={params} location={location} />
  }

  return <MenuRecipesPageWrapper params={params} location={location} />
}
